<template lang="pug">
    el-dialog(title="查看争议记录",width="60%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')

        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-table(:data="gradeData" border)
                    el-table-column(prop="matchName" label="比赛名称" align="center")
                    el-table-column(prop="debateId" label="比赛ID" align="center")
                    el-table-column(prop="debateTime" label="比赛日期" align="center")
                    el-table-column(prop="content" label="争议记录" align="center")
                    el-table-column(property="argue" label="操作" header-align='center',align='center')
                      template(slot-scope="scope")
                            <el-button type="text" @click="viewArgue(scope.row,'view')">查看详情</el-button>
                            <el-button type="text" @click="viewArgue(scope.row,'edit')">修改</el-button>
                            <el-button type="text" style="color:red" @click="deleteArgue(scope.row.debateId)">删除</el-button>
                el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        view-update-argue(v-if='argueDetailVisible', ref='viewArgue' @refreshData='refreshData')
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返 回
</template>
<script>
import ViewUpdateArgue from './view-update-argue'
export default {
  data () {
    return {
      argueDetailVisible: false,
      isCollapse: true,
      visible: false,
      ruleForm: {
        id: null,
        name: '',
        chairman: '',
        chairmanId: '',
        level: '',
        score: '',
        enrollTime: '',
        allWomen: '',
        matchType: '',
        playTime: []
      },
      gradeData: [{ matchName: '名字' }],
      totalPage: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: null,
      // 积分
      visible_jf: false,
      resons: '',
      jf_id: '',
      jfType: 0 //1扣除 0取消
    }
  },
  components: {
    ViewUpdateArgue
  },
  methods: {
    refreshData () {
      this.queryList()
    },
    // 查看或者修改争议
    viewArgue (row, oprType) {
      // console.log(id)
      this.argueDetailVisible = true
      this.$nextTick(() => {
        this.$refs.viewArgue.init(row, oprType)
      })
    },
    // 删除争议 待接入
    deleteArgue (id) {
      this.$confirm('是否删除争议记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl(`/cbClub/deleteDebateById/` + id),
            method: 'get'
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success('操作成功')
              this.refreshData()
            }
          })
          // this.argueHandle()
        })
        .catch(() => {
          this.$message.info('操作取消')
        })
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    init (id, row) {
      console.log(row, 123)
      this.visible = true
      this.gradeData = []
      //回
      this.ruleForm.id = id || ''
      this.ruleForm.name = row.name
      this.ruleForm.chairman = row.chairman
      this.ruleForm.chairmanId = row.chairmanId
      this.ruleForm.level = {
        1: '甲A',
        2: '甲B',
        3: '乙A',
        4: '乙B',
        5: '丙A',
        6: '丙B',
        7: '丁A',
        8: '丁B',
        9: '资格'
      }[row.level]
      this.ruleForm.yearScore = row.yearScore
      this.ruleForm.enrollTime = row.enrollTime
      this.ruleForm.allWomen = { 1: '是', 2: '否' }[row.allWomen]
      this.ruleForm.matchType = ''
      this.ruleForm.playTime = []
      this.queryList()
    },
    queryList () {
      this.$http({
        url: this.$http.adornUrl(
          `/cbClub/getDebateListByCbId/` + this.ruleForm.id
        ),
        method: 'get'
      }).then((res) => {
        if (res && res.code == 0) {
          this.gradeData = res.data.rows
          this.totalPage = res.data.total
        } else {
          this.gradeData = []
          this.totalPage = 0
        }
      })
    },
    // 分页
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.queryList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.queryList()
    },

    addOrUpdateHandle (row) {
      this.resons = ''
      this.visible_jf = true
      this.jf_id = row
      this.jfType = 1
    },
    memberManage (row) {
      this.resons = ''
      this.visible_jf = true
      this.jf_id = row
      this.jfType = 0
    },
    resons_save () {
      this.jf_id.status = this.jfType
      this.jf_id.remark = this.resons

      this.$http({
        url: this.$http.adornUrl(`/ctScore/update`),
        method: 'post',
        data: this.jf_id
      }).then((res) => {
        if (res && res.code == 0) {
          this.$message.success('操作成功！')
          this.visible_jf = false
        } else {
          this.$message.error('操作失败！')
        }
      })
    },
    queryHandle (id) {
      // 跳转
      ;(this.visible = false),
        this.$router.push({ path: '/ct/competition/club', query: { id: id } })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
  }
}
</script>
